import { inject, Injectable } from '@angular/core';
import { GlobalFiltersComponent } from '@observation/shared/components/global-filters/global-filters.component';
import { FilterAnalytic } from '../models/analytic.model';
import { UsageTrackingServiceInterface } from '../models/usage-tracking-service.interface';
import { FilterTrackingService } from './filter-tracking.service';
import { TrackingService } from './tracking.service';

@Injectable({ providedIn: 'root' })
export class SidenavFilterService
  extends FilterTrackingService
  implements UsageTrackingServiceInterface
{
  private readonly trackingService = inject(TrackingService);

  public addUsageTracking(
    element: GlobalFiltersComponent,
    args: [string, number]
  ): void {
    const filterAnalytic: FilterAnalytic = this.getFilterAnalytic(
      element.filterSelected.globalFilterDimensions[args[1]]?.dimensionId,
      args[0],
      element.dimensionNames
    );

    this.trackingService.addUsageTracking(filterAnalytic);
  }
}
